export default "__VITE_ASSET__299e82d5__"